import gql from 'graphql-tag';
import { client } from 'apollo/client';

export const GET_USER_INFO_QUERY = gql`
  query {
    me {
      id
      email
      username
      firstName
      lastName
      initials
      timezone
      admin {
        role
      }
      listing {
        id
      }
      organization {
        id
        name
        datePreference
        timePreference
        currency
        ownerId
        sampleWeddingStatus
        allowedWeddingCount
        isPaying
        autoNumberingInvoices
        wedpayEnabled
        stripeApEnabled
      }
      organizationMember {
        orgId
        permissions
        effectivePermissions
      }
      profileImage {
        resolutions
        key
        cropPosition
      }
      # profile_image_path
      isDisabled
      isPaused
      pausedAt
      isCancel
      cancelAt
      features
      weddings {
        id
        name
        weddingDate
        organizationId
        creationStatus
      }
      preferences {
        leads
        weddings
        weddingsDownload
        notes
        savedColors
        calendar
        general
      }
      billing {
        isDelinquent
        hasPaymentMethod
        planningSubscription {
          id
          code
          name
          isTrial
          isPromo
          isPro
          expiresAt
          isExpired
          endedAt
          isEnded
          startedAt
          remainingTrialDays
        }
      }
      isMasquerading
      isSettings
      isPro
      promos{
        codeIdentifier
        proSubscriptionCode
        indSubscriptionCode
        stripeCouponIdentifier
      }
      createdAt
      integrationsEnabled
      integrations{
        id
        email
        provider
        grantStatus
        loginCalendars{
          id
          integrationId
          calendarType
          name
          hexColor
          hexForegroundColor
          calendarsId
        }
      }
    }
  }
`;

export const GET_LOGIN_WEDDINGS = gql`
  query ($pageSize: Int!, $page: Int!) {
    loginWeddings(pageSize: $pageSize, page: $page) {
      total
      items {
        isEnabled
        weddingName
        weddingId
        creationStatus
        weddingDate
        allDayEvent
        startTime
        endTime
        timezone
        serviceType
        weddingAddress
        weddingLocation {
          id
          data
          city
          state
          formattedAddress
          country
        }
        weddingGuestCount
        weddingPartners {
          loginId
          name
          firstname
          lastname
          initials
          profileImage {
            resolutions
          }
          isLead
        }
        image306
      }
    }
  }
`;

export const fetchUserInfo = async () => {
  const results = await client.query({
    query: GET_USER_INFO_QUERY,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  return results;
};

export const fetchLoginWeddings = async (variables) => {
  const results = await client.query({
    query: GET_LOGIN_WEDDINGS,
    variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  return results;
};
